// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AlbumPayloadItem__container-d18f4f,
.AlbumPayloadItem__preview-f4c753,
.AlbumPayloadItem__preview-f4c753 > .AlbumPayloadItem__media-image-e44293 {
  position: absolute;
  left: 0;
  top: 0;
  width: 100% !important;
  height: 100% !important;
  background-color: inherit;
}

.AlbumPayloadItem__preview-f4c753 {
  background-color: var(--base-30);
}

.AlbumPayloadItem__my-item-bde708 .AlbumPayloadItem__preview-f4c753 {
  background-color: var(--addition-190);
}

.AlbumPayloadItem__preview-f4c753 > img {
  object-fit: cover;
}

.AlbumPayloadItem__icon-e20764 {
  fill: var(--addition-50);
}

.AlbumPayloadItem__uploader-f83b32 {
  color: var(--addition-50);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 48px;
  height: 48px;
  background-color: var(--addition-40_60);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/Payload/Album/AlbumPayloadItem/AlbumPayloadItem.styles.m.css"],"names":[],"mappings":"AAAA;;;EAGE,kBAAA;EACA,OAAA;EACA,MAAA;EACA,sBAAA;EACA,uBAAA;EACA,yBAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,qCAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,uCAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF","sourcesContent":[".container,\n.preview,\n.preview > .media-image {\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100% !important;\n  height: 100% !important;\n  background-color: inherit;\n}\n\n.preview {\n  background-color: var(--base-30);\n}\n\n.my-item .preview {\n  background-color: var(--addition-190);\n}\n\n.preview > img {\n  object-fit: cover;\n}\n\n.icon {\n  fill: var(--addition-50);\n}\n\n.uploader {\n  color: var(--addition-50);\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 48px;\n  height: 48px;\n  background-color: var(--addition-40_60);\n  border-radius: 50%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AlbumPayloadItem__container-d18f4f`,
	"preview": `AlbumPayloadItem__preview-f4c753`,
	"media-image": `AlbumPayloadItem__media-image-e44293`,
	"mediaImage": `AlbumPayloadItem__media-image-e44293`,
	"my-item": `AlbumPayloadItem__my-item-bde708`,
	"myItem": `AlbumPayloadItem__my-item-bde708`,
	"icon": `AlbumPayloadItem__icon-e20764`,
	"uploader": `AlbumPayloadItem__uploader-f83b32`
};
module.exports = ___CSS_LOADER_EXPORT___;
